<template>
<div class="login-wrapper">
  <form novalidate class="md-layout" @submit.prevent="login">
    <md-card class="md-layout-item">
      <md-card-header>
        <div class="md-title">Signup to KeiPanel</div>
      </md-card-header>

      <md-card-content>

        <div class="md-layout-item md-small-size-100">
          <md-field>
            <label>Username</label>
            <md-input v-model="email" type="email"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-100">
          <md-field>
            <label>Password</label>
            <md-input v-model="password" type="password"></md-input>
          </md-field>
        </div>

        <md-button class="md-raised md-primary" type="submit">Login</md-button>

      </md-card-content>
    </md-card>

    <md-snackbar :md-duration="duration" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackMessage}}</span>
      <md-button class="md-primary" @click="showSnackbar = false">Ok</md-button>
    </md-snackbar>

  </form>
</div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      showSnackbar: false,
      duration: 4000
    }
  },
  methods: {
    login () {
      var loginObj = {
        username: this.email,
        password: this.password
      }


      this.$http.post(`/auth/register/`, loginObj)
        .then(response => {
          localStorage.setItem('jwtToken', response.data.token)
          this.$router.push({
            name: 'AppLogin'
          })
        })
        .catch(e => {
          console.log(e.response.data.msg)
          this.showSnackbar = true
          this.snackMessage = e.response.data.msg
        })
    }
  }
}
</script>

<style>
.login-wrapper {
  width: 80%;
  height: 80%;
  margin: 15% auto;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #42a5f5 inset;
}

input:-webkit-autofill,
input:focus:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #42a5f5 inset;
}
</style>



// WEBPACK FOOTER //
// src/pages/AppSignup.vue